/**
 * Conversation-scope link keys shared by the objects endpoints.
 *
 * These mirror the canonical field names used by the API for linking
 * objects to conversations (`conversationId` / `conversationIds` /
 * `conversationLinks`).
 */

export const CONVERSATION_SCOPE_ID_KEY = 'conversationId' as const
export const CONVERSATION_SCOPE_IDS_KEY = 'conversationIds' as const
export const CONVERSATION_SCOPE_LINKS_KEY = 'conversationLinks' as const
export type ConversationScopeLink = { [CONVERSATION_SCOPE_ID_KEY]: string }
